import o,{keyframes as i}from"styled-components";import{theme as t}from"../../../../../theme.js";const r=i`
  0% {
    transform: rotate(0);
  }
  20% {
    transform: rotate(-30deg);
  }
  40% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(30deg);
  }
  80% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(0);
  }
`,e=o.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  > div {
    display: flex;
    gap: ${t.spacing*4}px;
    align-items: center;
  }
  > a {
    display: flex;
    align-items: center;
  }
  .overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: #0000004d;
    top: 0;
    left: 0;
    z-index: 999;
    cursor: auto;
  }
  .brand {
    > svg {
      width: 121px;
      height: 30px;
    }
  }
  @media screen and (max-width: ${t.breakpoints.xl}) {
    padding: 0 ${t.spacing*4}px;
  }
`,a=o.div`
  position: relative;
  cursor: pointer;
  a { 
    text-decoration: unset;
    color: inherit;
  }
  > span {
    border-radius: ${t.radius}px;
    background-color: ${t.colors.primary[500]};
    transition: background-color .2s ease-in-out;
    padding: ${t.spacing*2}px ${t.spacing*4}px;
    user-select: none;
    font-size: 12px;
    line-height: 20px;
    font-weight: 700;
    color: ${t.colors.shades[0]};
    display: flex;
    align-items: center;
    gap: ${t.spacing}px;
    > svg {
      width: 16px;
      height: 16px;
      transition: transform .2s ease-in-out;
      > g, path {
        fill: ${t.colors.shades[0]};
      }
      &.open {
        transform: rotate(180deg);
      }
    }
    
  }
  .dropdown {
    position: absolute;
    top: 42px;
    right: 0;
    z-index: 1000;
    width: ${t.maxWidth};
    padding: ${t.spacing*4}px;
    background-color: ${t.colors.shades[0]};
    border-radius: ${t.radius}px;
    transition: all .2s ease-in-out;
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 350fr));
      gap: ${t.spacing*4}px;  
    }
    .dropdown-title {
      color: ${t.colors.gray[800]};
      font-size: 20px;
      margin: 0 0 ${t.spacing*4}px;
    }
    .see-other {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${t.spacing*2}px;
      background-color: ${t.colors.gray[100]};
      color: ${t.colors.primary[500]};
      border: none;
      border-radius: ${t.radius}px;
      font-size: 14px;
      font-weight: 700;
      line-height: 24px;
      margin-top: ${t.spacing*6}px;
      text-decoration: unset;
      height: 48px;
      > svg {
        width: 24px;
        height: 24px;
        > g, path {
          fill: ${t.colors.primary[500]};
        }
        &:nth-child(2) {
          transform: rotate(-180deg);
        }
      }
    }
    &.close {
      opacity: 0;
      visibility: hidden;
      transform: translate(10px, -10px);
    }
    &.open {
      opacity: 1;
      visibility: visible;
      transform: translate(0px, 0px);
    }
  }
  &:hover {
    > span {
      background-color: ${t.colors.primary[400]};
      > svg {
        &.close {
          animation: ${r} .5s .5s ease-in-out;
        }
      }
    }
  }
  @media screen and (max-width: 1600px) {
    .dropdown {
      position: fixed;
      top: 56px;
      left: 50%;
      transform: translateX(-50%) !important;
      width: 90vw;
      /* z-index: 99; */
    }
  }
`;export{e as Container,a as DropdownButton};
